import { connect } from 'react-redux'
import { getPermission } from 'reduxpath/ducks/Impersonate'
import { sendJobEmail } from 'reduxpath/ducks/SendEmailToCreator'
import {
  getProjects,
} from 'reduxpath/ducks/Project/List'

import List from './units'

const mapStateToProps = state => ({
  data: state.ProjectList.data,
  orderStatus: state.Reference.statusDefinition.order,
  isLoading: state.ProjectList.isLoading,
  userEmail: state.Auth.me.user.email,
})

const mapDispatchToProps = dispatch => ({
  handleDetail(id) {
    return id
  },

  sendJobEmailHandler(id) {
    dispatch(sendJobEmail(id))
    const limit = 10
      const qs = {
        sort: `createdAt DESC`,
        limit: limit,
        skip: 0 * limit,
        where: {
          or: [
            { name: { like: `%` } },
            { brand: { like: `%` } },
            { firstName: { like: `%` } },
            { email: { like: `%` } }
          ],
        },
      }
    dispatch(getProjects(qs))
  },

  goesTopPlatform(profileId, userEmail, pageDestination, typeDestination) {
    return () => {
      dispatch(getPermission(profileId, userEmail, pageDestination, typeDestination))
    }
  },
})

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(List)
